var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGradeC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5H28H44C50.3513 0.5 55.5 5.64873 55.5 12V44C55.5 50.3513 50.3513 55.5 44 55.5H12C5.64873 55.5 0.5 50.3513 0.5 44V12Z",
    fill: "url(#paint0_linear_3315_18415)",
    stroke: "#AF8E76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7925 25.2653H33.4374C33.3578 24.7019 33.1954 24.2014 32.9502 23.7639C32.7049 23.3198 32.39 22.9419 32.0056 22.6304C31.6211 22.3188 31.177 22.0802 30.6732 21.9145C30.176 21.7488 29.6358 21.6659 29.0524 21.6659C27.9985 21.6659 27.0804 21.9277 26.2982 22.4514C25.516 22.9685 24.9095 23.7241 24.4786 24.7185C24.0477 25.7062 23.8323 26.906 23.8323 28.3179C23.8323 29.7696 24.0477 30.9893 24.4786 31.977C24.9161 32.9647 25.5259 33.7104 26.3081 34.2142C27.0903 34.718 27.9952 34.9699 29.0226 34.9699C29.5993 34.9699 30.1329 34.8937 30.6235 34.7412C31.1206 34.5887 31.5614 34.3667 31.9459 34.075C32.3304 33.7767 32.6486 33.4154 32.9005 32.9912C33.159 32.567 33.338 32.083 33.4374 31.5395L37.7925 31.5594C37.6798 32.494 37.3981 33.3955 36.9473 34.2639C36.5032 35.1257 35.9033 35.8979 35.1476 36.5807C34.3986 37.2568 33.5037 37.7938 32.463 38.1915C31.4289 38.5826 30.2589 38.7781 28.953 38.7781C27.1367 38.7781 25.5127 38.3671 24.0809 37.5452C22.6557 36.7232 21.5288 35.5333 20.7002 33.9756C19.8782 32.4178 19.4672 30.5319 19.4672 28.3179C19.4672 26.0973 19.8848 24.208 20.7201 22.6503C21.5553 21.0925 22.6888 19.906 24.1206 19.0906C25.5524 18.2687 27.1632 17.8577 28.953 17.8577C30.1329 17.8577 31.2267 18.0234 32.2343 18.3548C33.2485 18.6863 34.1467 19.1702 34.9289 19.8065C35.7111 20.4363 36.3474 21.2085 36.838 22.1233C37.3351 23.0381 37.6533 24.0854 37.7925 25.2653Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3315_18415",
    x1: 0,
    y1: 0,
    x2: 56,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D7456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175644,
    stopColor: "#B0937E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342321,
    stopColor: "#9D7456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCA18D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGradeC);
export default __webpack_public_path__ + "static/media/icon-grade-C.1627d4e4beeadb42d236770415938237.svg";
export { ForwardRef as ReactComponent };